import Image from 'next/image';
import React from 'react';
import {
  FlexImage,
  FlexImgSection,
  RatingContainerNew,
  ShowcaseNew,
} from './styled';
import { images } from '../../../Constants/ImageUrls';

const ProductShowcaseNew = (props) => {
  const { data, productInfo } = props;
  return (
    <ShowcaseNew>
      <div className="imgWrapper">
        <Image
          src={data?.product_image || data?.image_url}
          loading="lazy"
          quality={90}
          alt=""
          fill
          sizes="33vw"
        />
      </div>
      <div className="detailsContainer">
        <p className="pTitle">{data?.nickname || data?.title}</p>
        {data?.product_feature ? (
          <p className="features">{data?.product_feature}</p>
        ) : null}
        <div className="flex">
          <p className="price">{'₹ ' + data?.price}</p>
          <RatingContainerNew>
            <img src={images.newFilledStar} alt="" />
            <p>{data?.productRating}</p>
            <span>{'(' + data?.ratingCount + ')'}</span>
          </RatingContainerNew>
          <FlexImgSection>
            {data?.userImgs?.map((image, index) => {
              return (
                <FlexImage
                  src={image}
                  alt=""
                  key={'userImg' + index}
                  zIndex={index}
                />
              );
            })}
          </FlexImgSection>
          <p className="userBought">{data?.user_count}</p>
        </div>
        <button>
          <p>VIEW PRODUCT IN STORE</p>
          <img src={images.arrowWhite} alt="" />
        </button>
      </div>
    </ShowcaseNew>
  );
};

export default ProductShowcaseNew;
